import React, { useState, useEffect } from 'react';
import Modal from '../Elements/Modal/Modal';
import MainButton from '../Elements/MainButton/MainButton';
import SecondButton from '../Elements/SecondButton/SecondButton';
import MainInput from '../Elements/MainInput/MainInput';
import ErrorMessage from '../Elements/ErrorMessage/ErrorMessage';
import SuccessMessage from '../Elements/SuccessMessage/SuccessMessage';
import { requestRefund } from '../../services/TransactionService';
import './ProfileModals.css';  // Reuse styles

const RefundModal = ({ isOpen, onClose, transactionId, onSuccess }) => {
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const resetState = () => {
    setReason('');
    setError('');
    setSaving(false);
  };

  useEffect(() => {
    if (isOpen) resetState();
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!reason.trim()) {
      setError('Reason is required');
      return;
    }

    try {
      setSaving(true);
      await requestRefund(transactionId, reason.trim());
      setSuccess('Refund requested successfully.');
      onSuccess?.();
      setTimeout(onClose, 1500);  // Auto-close after success
    } catch (err) {
      setError(err.message || 'Refund request failed');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={saving ? onClose : onClose}
      title="Request Refund"
    >
      <form onSubmit={handleSubmit} className="profile-modal-form">
        <label>Transaction ID</label>
        <MainInput type="text" value={transactionId} readOnly className="profile-user-edit-input-readonly" />
        <label>Reason</label>
        <MainInput
          type="text"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Enter refund reason"
        />
        {error && (
          <div className="profile-user-edit-error">
            <ErrorMessage message={error} onClose={() => setError('')} />
          </div>
        )}
        {success && (
          <div className="profile-user-edit-success-wrapper">
            <SuccessMessage message={success} onClose={() => setSuccess('')} />
          </div>
        )}
        <div className="refund-modal-actions">
          <SecondButton onClick={onClose} disabled={saving}>Cancel</SecondButton>
          <MainButton onClick={handleSubmit} disabled={saving}>
            {saving ? 'Requesting...' : 'Request Refund'}
          </MainButton>
        </div>
      </form>
    </Modal>
  );
};

export default RefundModal;
